const TOKEN_KEY = 'loggedInToken'
const COUNTDOWN_KEY = 'countdownTime'
const LAST_ACTIVE_KEY = 'lastActiveTime'
export const SESSION_TIMEOUT_MS = 15 * 60 * 1000

/**
 * Returns sessionStorage if available, or null.
 * Shared across modules that need safe storage resolution.
 */
export const getSafeSessionStorage = () => {
  try {
    const testKey = '__tbd_storage_test__'
    sessionStorage.setItem(testKey, '1')
    sessionStorage.removeItem(testKey)
    return sessionStorage
  } catch (err) {
    return null
  }
}

const resolvedStorage = getSafeSessionStorage()

const memoryStore = {
  token: null,
  countdown: null,
  lastActive: null,
}

const persist = (key, value) => {
  if (!resolvedStorage) return
  if (value === null || value === undefined) {
    resolvedStorage.removeItem(key)
  } else {
    resolvedStorage.setItem(key, value)
  }
}

const read = key => {
  if (!resolvedStorage) return null
  return resolvedStorage.getItem(key)
}

const clearAuthToken = () => {
  memoryStore.token = null
  persist(TOKEN_KEY, null)
}

export const setLastActiveTime = timestamp => {
  memoryStore.lastActive = timestamp || null
  persist(LAST_ACTIVE_KEY, timestamp || null)
}

export const getLastActiveTime = () => {
  const stored = read(LAST_ACTIVE_KEY)
  if (stored) {
    memoryStore.lastActive = stored
    return stored
  }
  return memoryStore.lastActive
}

export const clearLastActiveTime = () => {
  memoryStore.lastActive = null
  persist(LAST_ACTIVE_KEY, null)
}

export const setCountdownTime = timestamp => {
  memoryStore.countdown = timestamp || null
  persist(COUNTDOWN_KEY, timestamp || null)
  setLastActiveTime(timestamp)
}

export const getCountdownTime = () => {
  const stored = read(COUNTDOWN_KEY)
  if (stored) {
    memoryStore.countdown = stored
    return stored
  }
  return memoryStore.countdown
}

export const clearCountdownTime = () => {
  memoryStore.countdown = null
  persist(COUNTDOWN_KEY, null)
}

export const clearAuthSessionState = () => {
  clearAuthToken()
  clearCountdownTime()
  clearLastActiveTime()
}

export const getAuthStorage = () => resolvedStorage
